<template>
  <div v-if="loading" class="native-loading" role="status" aria-live="polite">
    <span class="native-loading-spinner" aria-hidden="true" />
    <span>加载中…</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { isNativeLoading } from "@/utils/nativeLoading";

const loading = computed(() => isNativeLoading.value > 0);
</script>

<style scoped>
.native-loading {
  position: fixed;
  z-index: 1900;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgb(255 255 255 / 60%);
  color: #334155;
}

.native-loading-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #dbe7e3;
  border-top-color: #287d6a;
  border-radius: 50%;
  animation: native-spin 700ms linear infinite;
}

@keyframes native-spin {
  to { transform: rotate(360deg); }
}
</style>
